import { ApolloError } from "@apollo/client"


const removeExceptions = (message: string): string => {
    const [, ...rest] = message.split(":");
    return rest.slice(-1).join(" ").trim();
}

export const parseError = (error: ApolloError): string => {
    const message = error?.message;
    const defaultError = "Oops... Please try again, if the issue persists contact our support services";

    // CHECK - Message Result
    if (!message) return defaultError;

    const removeExceptionResult = removeExceptions(message);
    
    // CHECK - Remove Exception Result
    if (removeExceptionResult === " " || removeExceptionResult.length < 3) return defaultError;

    return removeExceptionResult;
}
